import { useEffect } from "react";
import { useNavigate } from "react-router-dom"

const WithAuth=(WrappedComponent)=>{
    const authcomponent=(props)=>{
        const router=useNavigate();
        const isAuthenticated=()=>{
            if(localStorage.getItem("token")){
                return true;
            }
            return false
        }
        useEffect(()=>{
            if(!isAuthenticated()){
                router("/auth")
            }
        },[])
        return <WrappedComponent {...props}/>
    }
    return authcomponent
}
export default WithAuth;